import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { push } from 'connected-react-router'

import {
  tryToGetPaginated,
  showTooltip,
  hideTooltip
} from 'actions/actions.export'

import CustomButton from 'kit/components/CustomButton/CustomButton.js'
import SimpleChart from 'kit/components/SimpleChart/SimpleChart.js'

import Hydrate from 'components/Hydrate/Hydrate.js'
import ComponentVersionBar from 'components/ComponentVersionBar/ComponentVersionBar.js'
import ComponentContentThumbnail from 'components/ComponentContentThumbnail/ComponentContentThumbnail.js'
import ActivityFeed from 'components/ActivityFeed/ActivityFeed'
import AgentGraph from 'components/AgentGraph/AgentGraph'

import tools from 'configs/config.component-tools'

import './ComponentHome.scss';



class ComponentHome extends Component {
  constructor(props){
    super(props);


    this.state = {

    }
  }

  componentWillMount(){
    const { dispatch, componentReducer } = this.props;

    dispatch(tryToGetPaginated({
      kind: 'components',
      id: this.props.id,
      collection: 'activity-log'
    }))
  }

  render(){

    const { dispatch, orgReducer, componentReducer, intelReducer, sharedReducer, userReducer, canWrite } = this.props;

    const component = componentReducer.cache[this.props.id];
    if(!component) return <span>component failed to load.</span>;

    const currentVersion = (component.versions || []).find(v => v.id === 'draft');

    if(!currentVersion) return <span/>;

    let modelData = intelReducer.llms.find(llm => llm.name === currentVersion.model) || {};

    let few_shots_with_knowledge = (currentVersion.few_shots || []).filter(f => f.knowledge_id);

    let knowledge_url = "/workbench/" + component.scope + "/agents/" + component.id + "/few_shots";
    if(few_shots_with_knowledge.length === 1){
      knowledge_url += '/' + few_shots_with_knowledge[0].id;
    }

  
    let mermaidTooltips = {
      LLM_gen: {
        tooltip: "The LLM that generates the agent's final output response.",
        icon: "brain text-component",
        linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/model"
      },
      OUTPUT: {
        icon: "arrow-from-left text-semi-muted text-semi-muted",
        tooltip: "The final output response of the agent."
      },
      INPUT: {
        icon: "arrow-to-right text-semi-muted",
        tooltip: "The input data containing messages and variables to be processed.",
      }
    }

    let mermaidMarkdown = `stateDiagram-v2 
    DIRECTION LR
    LLM_gen --> OUTPUT`;

    mermaidTooltips.CONTEXT_OPTIONS = {
      tooltip: <div>This is a merge point for all instructions and the input messages.
        <br/><br/>
        {
          currentVersion.context_cap_method === "truncate" &&
          <span>
            Based on your current settings, the agent will automatically truncate the context to the most recent messages that fit within the model's context window before passing it to the LLM.
          </span>
        }
        {
          currentVersion.context_cap_method === "error" &&
          <span>
            Based on your current settings, the agent will automatically throw an error if the context exceeds the model's context window.
          </span>
        }
        {
          currentVersion.context_cap_method === "summarize" &&
          <span>
            Based on your current settings, an additional LLM will be used to summarize older messages that don't fit within the model's context window.
          </span>
        }

      </div>,
      icon: 'cut',
      linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/context-options"
    }

    if(currentVersion.few_shots.length > 0){

      mermaidMarkdown += `
      INPUT --> CONTEXT_OPTIONS`;

      for(var i in currentVersion.few_shots){
        if(currentVersion.few_shots[i].deleted) continue;
        if(!currentVersion.few_shots[i].messages) continue;
        

        mermaidMarkdown += `
        INST_${currentVersion.few_shots[i].id} --> CONTEXT_OPTIONS`;

        mermaidTooltips["INST_" + currentVersion.few_shots[i].id] = {
          tooltip: <div>This instruction is prepped to be processed by the agent.<br/><br/>
            <small className="text-400"><i>{currentVersion.few_shots[i].messages[0].content.slice(0,32)}...</i></small>
          </div>,
          icon: "comment-alt-smile text-semi-muted",
          linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/few_shots/" + currentVersion.few_shots[i].id
        }

        // find variables that are connected to this few shot
        for(var j in currentVersion.variables){
          let variable = currentVersion.variables[j];
          if((currentVersion.few_shots[i].messages || []).find(m => m.content.includes('${' + variable.key + '}'))){
            mermaidMarkdown += `
            VAR_${currentVersion.variables[j].id} --> INST_${currentVersion.few_shots[i].id}`;

            mermaidTooltips["VAR_" + currentVersion.variables[j].id] = {
              tooltip: "The value of " + variable.key + " is set and ready to be passed into an instruction.",
              icon: "brackets-curly text-semi-muted",
              linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
            }

            // if this is a rag variable add that
            if(variable.source === 'rag'){
              mermaidMarkdown += `
              KB_${variable.id} --> VAR_${currentVersion.variables[j].id}`;

              mermaidTooltips["KB_" + variable.id] = {
                tooltip: "Relevant chunks from this knowledge base are gathered and prepped to take the value of " + variable.key + ".",
                icon: "book-spells text-knowledge",
                linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
              }

              // if naive rag, map input messages to the search, then search to the kb
              if(variable.knowledge_link_method === 'naive'){
                mermaidMarkdown += `
                INPUT --> SEARCH_${variable.id}
                SEARCH_${variable.id} --> KB_${variable.id}`;

                mermaidTooltips["SEARCH_" + variable.id] = {
                  tooltip: "The most recent message from the input data is used to search the knowledge base for relevant information.",
                  icon: "search text-semi-muted",
                  linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
                }

              } else if(variable.knowledge_link_method === 'manual'){
                // do nothing
              } else if(variable.knowledge_link_method === 'agentic_basic'){
                // connect a unique new LLM to a naive search
                mermaidMarkdown += `
                INPUT --> INSTRUCTION_MERGE_${variable.id}
                
                INST_${variable.id} --> INSTRUCTION_MERGE_${variable.id}
                INSTRUCTION_MERGE_${variable.id} --> LLM_${variable.id}
                LLM_${variable.id} --> SEARCH_${variable.id}
                SEARCH_${variable.id} --> KB_${variable.id}
              
                `;

                // add tooltips and icons for each of these, all linking to the variable page 
                // mermaidTooltips["CONTEXT_OPTIONS_" + variable.knowledge_id] = {
                //   tooltip: "The instructions for this variable are passed to a unique LLM that is designed to handle this variable.",
                //   icon: "comment-alt-smile text-semi-muted",
                //   linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
                // }

                mermaidTooltips["INST_" + variable.id] = {
                  tooltip: "Instructions for how this RAG LLM should generate search text.",
                  icon: "comment-alt-smile text-semi-muted",
                  linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
                }

                mermaidTooltips["INSTRUCTION_MERGE_" + variable.id] = {
                  tooltip: "The instructions for how to generate search text are merged with the input messages.",
                  icon: "comments-alt text-semi-muted",
                  linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
                }

                mermaidTooltips["LLM_" + variable.id] = {
                  tooltip: "The LLM that is responsible for generating search text based on the current conversation and its instructions.",
                  icon: "brain text-component",
                  linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
                }

                mermaidTooltips["SEARCH_" + variable.id] = {
                  tooltip: "The output of the LLM is used to search the knowledge base for relevant information.",
                  icon: "search text-semi-muted",
                  linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/variables/" + currentVersion.variables[j].id
                }
                
              }
            } else {
              mermaidMarkdown += `
              INPUT --> VAR_${currentVersion.variables[j].id}`;
            }
          }
        }
      }
    } else if(currentVersion.context_cap_method === "error"){
      // no few shots and no context settings 
      mermaidMarkdown += `
      INPUT --> LLM_gen`;
    } else {
      // no few shots but yes context settings
      mermaidMarkdown += `
      INPUT --> CONTEXT_OPTIONS`;
    }

    // if context settings are set, connect to the LLM
    if(currentVersion.context_cap_method === "truncate"){
      mermaidMarkdown += `
      CONTEXT_OPTIONS --> LLM_gen`;
    } else if(currentVersion.context_cap_method === "summarize"){
      mermaidMarkdown += `
      CONTEXT_OPTIONS --> LLM_summarize
      SUMMARIZE_INSTRUCTIONS --> LLM_summarize
      LLM_summarize --> CONTEXT_OPTIONS_2
      CONTEXT_OPTIONS_2 --> LLM_gen`;
      
      // add mermaidTooltips for all of these that all linkTo context options
      mermaidTooltips.LLM_summarize = {
        tooltip: "An additional LLM that summarizes older messages that don't fit within the model's context window.",
        icon: "brain text-component",
        linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/context-options"
      }

      mermaidTooltips.SUMMARIZE_INSTRUCTIONS = {
        tooltip: "The instructions on how to summarize older messages are passed to the summarizing LLM.",
        icon: "comment-alt-smile text-semi-muted",
        linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/context-options"
      }

      mermaidTooltips.CONTEXT_OPTIONS_2 = {
        tooltip: "The summarized older messages are merged with the recent messages and passed to the output-generating LLM.",
        icon: "comments-alt text-semi-muted",
        linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/context-options"
      }
    } else if(currentVersion.context_cap_method === "error" && currentVersion.few_shots.length > 0){
      mermaidMarkdown += `
      CONTEXT_OPTIONS --> LLM_gen`;
    }


    if(currentVersion.functions.length > 0){
      for(var i in currentVersion.functions){
        mermaidMarkdown += `
        LLM_gen --> FUNC_${currentVersion.functions[i].id}`;

        mermaidTooltips["FUNC_" + currentVersion.functions[i].id] = {
          tooltip: "This function is used to process the agent's final output response.",
          icon: "code text-project text-semi-muted",
          linkTo: "/workbench/" + component.scope + "/agents/" + component.id + "/functions/" + currentVersion.functions[i].id
        }
      }
    }


    return <div className="component-home">
      
      <ComponentVersionBar id={component.id}/>
      
      <div className="row row-eq-height margin-top-1rem">
        <div className="col-md-12 ">
          <div className="box box-half-pad">
            <div className="flex-split margin-bottom-05rem flex-split-align-start">
              <h5 className="no-margin ">Agent Chain Map</h5>
              <span className="text-muted">
                <i 
                  className="fal fa-info-circle"
                  onMouseEnter={e => {
                    dispatch(showTooltip({
                      el: e.target,
                      nobr: false,
                      position: 'bottom',
                      content: <div style={{maxWidth: 350}} className="text-400">
                        <span className="text-900 no-margin">What's this?</span>
                        <p className="no-margin-top thin-line-height">
                          <small>
                            This is an auto-generated map of the flow of information through the agent. Each node represents a step in the process, and the arrows show the direction of information flow. As you make changes to the agent's design, this map will update to reflect the new flow.
                          </small>
                        </p>
                        <p className="no-margin-bottom thin-line-height">
                          <small>
                            This feature is still in development and may not always accurately reflect the agent's exact behavior. 
                          </small>
                        </p>
                      </div>
                    }))
                  }}
                  />
              </span>
            </div>
            <div>
            <small className="text-muted">
                This is a map of the agent's possible chain of operations based on its current design.
              </small>
            </div>
            <AgentGraph
              mermaidMarkdown={mermaidMarkdown}
              tooltipLookup={mermaidTooltips}
              gridSize={30}/>

            <div className="list-right">
              
            </div>
          </div>
        </div>
      </div>

      

      <div className="row row-eq-height margin-top-1rem">
        <div className="col-md-4 flex-column-stretch">
          <Link to={"/workbench/" + component.scope + "/agents/" + component.id + "/model"} className="text-400 link-no-decoration box flex-grow box-half-pad">
            <div className="flex-split margin-bottom-05rem flex-split-align-start">
              <h5 className="no-margin ">Configured Model</h5>
              <small className="text-muted"><i className="fal fa-brain"/></small>
            </div>
            <div className="list-left">
              {(modelData.provider === 'OpenAI' || modelData.provider === undefined) && <img src="/img/openai_logo_small.png" width="30"/>}
              {modelData.provider === 'Google PaLM2' && <img src="/img/palm2_logo_small.png" width="30"/>}
              {modelData.provider === 'Google Gemini' && <img src="/img/gemini_logo_small.png" width="30"/>}
              {modelData.provider === "Anthropic" && <img src="/img/anthropic_logo_small.png" width="30"/>}
              {modelData.provider === "Meta" && <img src="/img/meta_logo_small.png" width="30"/>}

              <div>
                <div color="text-components">
                  {modelData.name}
                </div>
                <small className="text-muted">by {modelData.provider}</small>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-4 flex-column-stretch">
          
          <Link to={knowledge_url} className="text-400 link-no-decoration box flex-grow box-half-pad">
            <div className="flex-split margin-bottom-05rem flex-split-align-start">
              <h5 className="no-margin ">Linked Knowledge</h5>
              <small className="text-muted"><i className="fal fa-link"/></small>
            </div>
            <div className="thin-line-height">
              {
                few_shots_with_knowledge.length === 0 ?
                <small className="text-muted">
                  This agent has not been connected to any of your organization's knowledge.
                </small>
                :
                few_shots_with_knowledge.length === 1 ?
                <small className="">
                  This agent has one linked Knowledge Base.
                </small>
                :
                <small className="">
                  There are {few_shots_with_knowledge.length} Knowledge Bases linked to this agent.
                </small>
              }
            </div>
          </Link>
        </div>
        <div className="col-md-4 flex-column-stretch">
          <Link to={"/workbench/" + component.scope + "/agents/" + component.id + "/versions"} className="text-400 link-no-decoration box flex-grow box-half-pad">
            <div className="flex-split margin-bottom-05rem flex-split-align-start">
              <h5 className="no-margin ">Versions</h5>
              <small className="text-muted"><i className="fal fa-history"/></small>
            </div>
            <div className="thin-line-height">
            {
              component.current_version === 'draft' ?
              <small className="text-muted">
                This agent is still in draft mode and has not been published yet.
              </small>
              :
              <small>
                Currently on version {component.current_version}, with {component.versions.length - 1} previous version{component.versions.length - 1 === 1 ? "" : "s"}.
              </small>
            }
            </div>
          </Link>
        </div>
      </div>
      <hr/>
      <div className="row">
        <ActivityFeed id={component.id} kind="components"/>
      </div>
    </div>
  }
}


const mapStateToProps = (state) => {
  const { userReducer, componentReducer, intelReducer, sharedReducer, orgReducer } = state;

  return {
    userReducer, 
    componentReducer,
    intelReducer,
    sharedReducer,
    orgReducer
  }
}

export default connect(mapStateToProps)(ComponentHome);

  